import { ref, onMounted, onUnmounted } from 'vue'

const MOBILE_BREAKPOINT = 992

export function useMediaMobile(breakpoint = MOBILE_BREAKPOINT) {
  const isMobile = ref(false)

  const update = () => {
    isMobile.value = window.innerWidth < breakpoint
  }

  onMounted(() => {
    update()
    window.addEventListener('resize', update)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', update)
  })

  return { isMobile }
}
